import { InventoryItem } from "../../app/resources/types";
import type { LuckyWheelReward, LuckyWheelWeightData } from './types';

export const LUCKY_WHEEL_MIN_LEVEL = 4;
export const RESET_SPIN_HOURS = [4, 12, 20];
export const MAX_AD_SPINS_T1 = 2;
export const MAX_AD_SPINS_ROW = 4;

export const luckyWheelRewards: LuckyWheelWeightData[] = [
  { odds: 0.0202, isJackpot: true },
  { odds: 0.303, reward: { resource: InventoryItem.Coin, quantity: 25 } },
  { odds: 0.1414, reward: { resource: InventoryItem.Lives, quantity: 1 } },
  { odds: 0.202, reward: { resource: InventoryItem.Coin, quantity: 50 } },
  { odds: 0.0404, reward: { resource: InventoryItem.BoosterRedraw, quantity: 1 } },
  { odds: 0.101, reward: { resource: InventoryItem.Coin, quantity: 75 } },
  { odds: 0.1414, reward: { resource: InventoryItem.UnlimitedLivesMinutes, quantity: 30 } },
  { odds: 0.0505, reward: { resource: InventoryItem.Coin, quantity: 250 } },
];

export const dailyJackpotRewards: LuckyWheelReward[] = [
  { resource: InventoryItem.Coin, quantity: 1000 }, // Sunday
  { resource: InventoryItem.BoosterHammer, quantity: 1 }, // Monday
  { resource: InventoryItem.Coin, quantity: 1000 }, // Tuesday
  { resource: InventoryItem.BoosterRedraw, quantity: 2 }, // Wednesday
  { resource: InventoryItem.BoosterUndo, quantity: 1 }, // Thursday
  { resource: InventoryItem.Coin, quantity: 1500 }, // Friday
  { resource: InventoryItem.BoosterMove, quantity: 2 }, // Saturday
];